import React from 'react'

export default function NoDataLabel() {
  return (
    <div className='no-data-label'>No Data Found.</div>
  )
}
